"use strict";
exports.__esModule = true;
var angular = require("angular");
var psw_login_component_1 = require("./psw-login/psw-login.component");
var config_1 = require("../../config");
function apiVersionCheck(required, current) {
    if (!required) {
        return true;
    }
    if (!current) {
        return false;
    }
    if (required.trim() === current.trim()) {
        return true;
    }
    var result = false;
    var reqNumbers = required.split('.');
    var curNumbers = current.split('.');
    if (reqNumbers.length === curNumbers.length) {
        for (var i = 0; i < reqNumbers.length; i++) {
            if (parseInt(curNumbers[i]) > parseInt(reqNumbers[i])) {
                result = true;
                break;
            }
            else if (parseInt(curNumbers[i]) < parseInt(reqNumbers[i])) {
                break;
            }
        }
    }
    return result;
}
exports.apiVersionCheck = apiVersionCheck;
angular.module('smartorg.r6.views.login', [psw_login_component_1["default"]]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/login', {
            template: require('./login-view.controller.html'),
            controller: 'LoginCtrl'
        });
        $routeProvider.when('/login2', {
            template: require('./login-view.controller.html'),
            controller: 'LoginCtrl'
        });
    }]).controller('LoginCtrl', [
    '$scope', '$location', '$timeout', 'config', 'versionlog', 'shareLink',
    function ($scope, $location, $timeout, config, versionlog, shareLink) {
        var smartorgApi = config.smartorg;
        $scope.smartorgApi = config.smartorg;
        var latestVersion = versionlog.versions.length > 0 ? versionlog.versions[0] : {};
        var requiredApiVersion = latestVersion.apiVersion;
        $scope.currentVersion = latestVersion.version;
        $scope.loginDisabled = false;
        $scope.loading = true;
        $scope.errorMessage = '';
        $scope.showPasswordLogin = true;
        var usePsw = $location.path() === '/login2';
        function loadVersions() {
            smartorgApi.getServerConfig().then(function (response) {
                var defaultAuth = response.defaultAuth, apiVersion = response.apiVersion;
                if (defaultAuth === 'AZURE' && !usePsw) {
                    $scope.azureUrl = config_1.BACKEND_DOMAIN + "/" + config_1.API_ENDPOINT + "/framework/login/c";
                    $scope.showPasswordLogin = false;
                    window.location.replace($scope.azureUrl);
                    return;
                }
                if (defaultAuth === 'APPLE' && !usePsw) {
                    $scope.azureUrl = config_1.BACKEND_DOMAIN + "/" + config_1.API_ENDPOINT + "/framework/login/d";
                    $scope.showPasswordLogin = false;
                    window.location.replace($scope.azureUrl);
                    return;
                }
                var msg = '';
                if (apiVersion.calcEngineMessage.unreachable) {
                    msg += apiVersion.calcEngineMessage.msg;
                }
                else {
                    if (!apiVersionCheck(requiredApiVersion, apiVersion.controllerVersion)) {
                        msg += 'Controller version is too old.';
                    }
                    if (apiVersion.calcEngineMessage.tooOld) {
                        msg += apiVersion.calcEngineMessage.msg;
                    }
                    if (apiVersion.monoMessage.tooOld) {
                        msg += apiVersion.monoMessage.msg;
                    }
                }
                stopLoadingSpin();
                if (msg !== '') {
                    disableLogin(msg);
                }
            })["catch"](function (err) {
                stopLoadingSpin();
                if (err.status == 404) {
                    disableLogin('Controller version is too old.');
                }
                else { // if (err.status == 0)
                    disableLogin('Cannot access API. Hostname being used is likely a mismatch.');
                }
                console.warn(err);
            });
        }
        function disableLogin(errorMessage) {
            $scope.errorMessage = errorMessage;
            $scope.loginDisabled = true;
        }
        function autoLogin() {
            if (smartorgApi.protocols.hasToken()) {
                smartorgApi.authenticateThroughToken().then(function (userInfo) {
                    smartorgApi.protocols.credentials = {
                        username: userInfo.username,
                        isAdmin: userInfo.is_admin
                    };
                    $location.path('/firstpage');
                    $timeout();
                })["catch"](function (err) {
                    console.error(err);
                    loadVersions();
                });
            }
            else {
                loadVersions();
            }
        }
        function stopLoadingSpin() {
            $scope.loading = false;
            $timeout();
        }
        function getInfoFromShorten() {
            if ($location.search() && $location.search()['s']) {
                var key = $location.search()['s'];
                localStorage.setItem('shortUrl', key);
                $location.search('s', null);
            }
        }
        getInfoFromShorten();
        autoLogin();
    }
]);
exports["default"] = 'smartorg.r6.views.login';
//# sourceMappingURL=login-view.controller.js.map


// WEBPACK FOOTER //
// ./app/views/login2/login-view.controller.js